
import React from "react";
import BenneRequestForm from "@/components/BenneRequestForm";

const RequestFormSection: React.FC = () => {
  return (
    <div id="request-form" className="mt-16 bg-white rounded-lg shadow-lg p-8">
      <h2 className="text-2xl font-bold text-fabre-gray mb-6 text-center">Demande de location en ligne</h2>
      <p className="text-gray-600 mb-8 text-center max-w-3xl mx-auto">
        Remplissez le formulaire ci-dessous pour nous faire part de vos besoins en location de bennes. 
        En cliquant sur "Envoyer par email", votre client de messagerie s'ouvrira automatiquement avec un message pré-rempli.
      </p>
      <BenneRequestForm />
    </div>
  );
};

export default RequestFormSection;
